import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { baseAPI } from '../../services/baseAPI';

function ApprovalPelunasanPinjamBarang() {
  const { id, iduser } = useParams();
  const history = useHistory();
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);

  const [empDataPinjaman, setEmpDataPinjam] = useState([]);


  // CONTROLLER

  const fetchDataPinjaman = async () => {
    setIsLoading(true);
    await baseAPI 
      .get(`/v1/statusbelibarang/${iduser}`, {
         headers: { Authorization: `Bearer ${token}` } 
      })
      .then((res) => {
        const data = res.data.data.belumlunas;
        let dataAjuan = [];
        data.forEach(e => {
          dataAjuan.push({
            notrxdetailbarang: e.notrxdetailbarang,
            npp_anggota: e.npp_anggota,
            name_anggota: e.name_anggota,
            sisapokok: "Rp." + parseFloat(((e.lama - e.cicilan_ke) * (e.plafond / e.lama)).toFixed()).toLocaleString('id-ID'),
            jasabulanRp: "Rp." + parseFloat(e.jasa_bulan).toLocaleString('id-ID'),
            total_lunas: "Rp." + parseFloat((((e.lama - e.cicilan_ke) * (e.plafond / e.lama)) + (e.jasa_bulan * (e.lama - e.cicilan_ke))).toFixed()).toLocaleString('id-ID'),
            status: e.status,
            plafond: e.plafond,
            lama: e.lama,
            cpokok: e.cpokok,
            jasa_bulan: e.jasa_bulan,
            trxdetailbarang: e.trxdetailbarang,
            jenis_barang: e.jenis_barang,
            spesifikasi_barang: e.spesifikasi_barang,
            id_users: e.id_users,
            cicilan_ke: e.cicilan_ke,
            id: e.id
          })
        });
        setEmpDataPinjam(dataAjuan[0]);
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: 'error',
          title: `Gagal mengambil data`,
          showConfirmButton: false,
          timer: 1500
        })
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const updatePinjaman = async (id, idUser, status) => {
    Swal.fire({
      title: 'Apakah anda akan menyetujui pelunasan pinjaman ini?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Ya',
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const body = new FormData();
        body.append('update_data', JSON.stringify(empDataPinjaman));
        body.append('status', status === "melunasi" ? "Lunas" : null);

        baseAPI
          .put(`/v1/detailpinjambarang/${id}/${idUser}`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "Pengajuan pelunasan pinjaman berhasil.",
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`berhasil upload ${JSON.stringify(res)}`);
            history.push(`/pinjambarang/listpelunasanpinjambarang`);
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Pengajuan pelunasan pinjaman gagal.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
            fetchDataPinjaman(idUser);
          })
      }
    });

  }

  useEffect(() => {
    // if (user.role === USP) {
      fetchDataPinjaman(iduser);
    // };
  }, [token]);

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Data Pinjaman Barang</Link> /{' '}
              <Link to='/pinjambarang/listpelunasanpinjambarang' style={{ color: '#333' }}>List Pelunasan Pinjaman Barang</Link> /{' '}
              <Link to='#' style={{ color: '#333' }}>Approval Pelunasan Pinjaman Barang</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Pelunasan Pinjaman Barang Anggota</b></p>
                <p>Silahkan cek data pinjaman sebelum menyetujui pelunasan.</p>
              </div>

              {/* Tanggal Pengajuan */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Tanggal Pelunasan
                </label>
                <input
                  defaultValue={moment().format("DD/MM/yyyy")}
                  placeholder='Tanggal pelunasan'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* No Pinjaman */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  No Pinjaman
                </label>
                <input
                  defaultValue={empDataPinjaman.notrxdetailbarang}
                  placeholder='No pinjaman'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* NPP */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  NPP Anggota
                </label>
                <input
                  defaultValue={empDataPinjaman.npp_anggota}
                  placeholder='Employee npp'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Name */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Nama Anggota
                </label>
                <input
                  defaultValue={empDataPinjaman.name_anggota}
                  placeholder='Employee name'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Sisa waktu cicilan */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Sisa Lama Cicilan
                </label>
                <input
                  defaultValue={(empDataPinjaman.lama - empDataPinjaman.cicilan_ke)}
                  placeholder='Sisa pokok'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Sisa pokok pinjaman fix */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Sisa Pokok
                </label>
                <input
                  defaultValue={empDataPinjaman.sisapokok}
                  placeholder='Sisa pokok'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Jasa */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Jasa per Bulan
                </label>
                <input
                  defaultValue={empDataPinjaman.jasabulanRp}
                  placeholder='Jasa Bulan'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Total Pelunasan */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Total Pelunasan
                </label>
                <input
                  defaultValue={empDataPinjaman.total_lunas}
                  placeholder='Total pelunasan'
                  className="form-control"
                  readOnly
                />
              </div>

              <div className='col-md-2'>
                <label className='form-label'>
                  Status:
                </label>
                <span className='badge' style={{backgroundColor: '#333'}}>{empDataPinjaman.status}</span>
              </div>

              <div className='col-md-12'>
                <button
                  type="button"
                  disabled={empDataPinjaman.sisapokok != null ? false : true}
                  className='btn btn-danger col-md-12'
                  style={{backgroundColor: '#CD5C08'}}
                  onClick={() => updatePinjaman(empDataPinjaman.id, empDataPinjaman.id_users, "melunasi")}
                >
                  Setujui Pelunasan
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default ApprovalPelunasanPinjamBarang;